import { useEffect, useState } from "react";
import styles from "./styles.module.css";
export default function JustifyContent({ value, onChange }) {
  const [_value, _setValue] = useState("");

  useEffect(() => {
    _setValue(value);
  }, [value]);

  const handleSelect = (value) => {
    _setValue(value);
    onChange(value);
  };

  return (
    <div style={{ display: "flex" }}>
      <SelectButton
        selected={_value}
        setSelected={handleSelect}
        text="0"
        value={0}
      />
      <SelectButton
        selected={_value}
        setSelected={handleSelect}
        text="1"
        value={1}
      />
      <SelectButton
        selected={_value}
        setSelected={handleSelect}
        text="2"
        value={2}
      />
      <SelectButton
        selected={_value}
        setSelected={handleSelect}
        text="3"
        value={3}
      />
    </div>
  );
}

const SelectButton = ({ text, value, selected, setSelected }) => {
  return (
    <div
      className={
        value === selected
          ? `${styles.selectButton} ${styles.selected}`
          : styles.selectButton
      }
      onClick={() => setSelected(value)}
    >
      {text}
    </div>
  );
};
